module.exports = __webpack_public_path__ + "media/images/home/arrow-down-68c2e0cd61d8f61e6fe20dfdd68966d3.png";